import { gridQuery, handler, HandlerBody } from '.';
import * as model from '../model';

function menuHandler(body: HandlerBody) {
  return handler('/Handlers/Menu.ashx', body, false)
}

interface WrapupNode {
  folder: model.Wrapup & { folder: true }
  expanded: boolean
}

function parseXml(xml: string): Element {
  return new DOMParser().parseFromString(xml, 'application/xml').documentElement
}

function parseNode(n: Element): WrapupNode {
  return {
    folder: {
      id: n.getAttribute('ID') || '',
      name: n.getAttribute('Text') || '',
      folder: true,
    },
    expanded: n.getAttribute('Expanded') === 'True',
  }
}

async function getWrapupFolders(folderId: string) {
  const xml = await menuHandler({
    command: 'wrapupfolders',
    value: folderId,
  })

  return [ ...parseXml(xml).children ].map(n => parseNode(n).folder)
}

export async function getWrapupsAndExpand(folderId: string) {
  const xml = await menuHandler({
    command: 'wrapupfolders',
    selected: folderId,
  })

  const result: Record<string, model.Wrapup[]> = {}
  traverse(parseXml(xml).children, 'SYS')

  return result

  function traverse(nodes: HTMLCollection, parentId: string) {
    result[parentId] = []
    for (const node of nodes) {
      const wrapup = parseNode(node)
      result[parentId].push(wrapup.folder)

      if (wrapup.expanded) {
        traverse(node.children, wrapup.folder.id)
      }
    }
  }
}

async function getWrapupItems(server: string, id: string, folderId: string) {
  return (await gridQuery('wrapupcodes', '', server, model.EventSubscription.None, id, folderId)).rows.filter(row => row.wrapupFolderId === folderId).map<model.Wrapup>(row => ({
    id: row.id,
    name: row.description,
    folder: false,
  }))
}

export async function getWrapups(mySelf: model.Identifier, folderId: string = 'SYS') {
  const [folders, items] = await Promise.all([getWrapupFolders(folderId), getWrapupItems(mySelf.server, mySelf.id, folderId)])
  return [...folders, ...items]
}
